const Language = {
  Dutch: 'Dutch',
  English: 'English',
  French: 'French',
};

export default Language;
